module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Sarah-Yeoh-1e891776b99076ebdeff9156ea57cfe6.jpg";